/* eslint-disable */
import axios from 'axios';
import http from './http';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';

// --- Interfaces
export interface ChatMessageRequest {
  userId: string;
  chatId: string;
  from: 'user' | 'bot';
  content: string;
  file?: File;
}

export interface ChatMessageResponse {
  reply: string;
  fileUrl?: string;
}

// --- API Call
// export async function sendMessageApi(data: ChatMessageRequest): Promise<ChatMessageResponse> {
//   try {
//     const token = localStorage.getItem('authToken');
//     const headers: Record<string, string> = {
//       'Content-Type': data.file ? 'multipart/form-data' : 'application/json',
//       ...(token ? { Authorization: `Bearer ${token}` } : {}),
//     };

//     if (data.file) {
//       const formData = new FormData();
//       formData.append('userId', data.userId);
//       formData.append('chatId', data.chatId); // Dynamic chat session
//       formData.append('from', data.from);
//       formData.append('content', data.content);
//       formData.append('file', data.file);

//       const res = await http.post<ChatMessageResponse>('/chat/message', formData, { headers });
//       return res.data;
//     } else {
//       const res = await http.post<ChatMessageResponse>('/chat/message', data, { headers });
//       return res.data;
//     }
//   } catch (err: any) {
//     if (axios.isAxiosError(err)) {
//       throw new Error(err.response?.data?.message || 'Chatbot API Error');
//     }
//     throw err;
//   }
// }

export async function sendMessageApi(data: ChatMessageRequest): Promise<ChatMessageResponse> {
  try {
    const token = localStorage.getItem('authToken');
    const headers: Record<string, string> = {
      'Content-Type': data.file ? 'multipart/form-data' : 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };

    const endpoint = `/chat/message/${data.chatId ?? ''}`;

    if (data.file) {
      const formData = new FormData();
      formData.append('userId', data.userId);
      formData.append('chatId', data.chatId);
      formData.append('from', data.from);
      formData.append('content', data.content);
      formData.append('file', data.file);

      const res = await http.post<ChatMessageResponse>(endpoint, formData, { headers });
      return res.data;
    } else {
      const res = await http.post<ChatMessageResponse>(endpoint, data, { headers });
      return res.data;
    }
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      throw new Error(err.response?.data?.message || 'Chatbot API Error');
    }
    throw err;
  }
}

// --- React Query Mutation Hook (for use in the component)
export const useSendChatMessage = (): UseMutationResult<ChatMessageResponse, Error, ChatMessageRequest, void> =>
  useMutation({
    mutationFn: sendMessageApi,
    onSuccess: () => AlertAdapter('Message sent successfully.', 'success'),
    onError: (error: Error) => AlertAdapter(error.message || 'Failed to send message.', 'error'),
  });

// --- Optional legacy export
export const ChatbotService = { sendMessageApi };
